module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Z8rz"))).then(() => parcelRequire('hEqeo'));